<template>
    <modal :hide-footer="true" :id="modalId" title="Update Data" size="xl">
        <form-generator
            class="modal-form-generator"
            :results="{}"
            :surveyJSON="currentSurveyJSON"
            :onCompleted="onUpdateData"
        />
    </modal>
</template>

<script>
    import { defineAsyncComponent } from 'vue';
    import modal from '../../../../generic/modal/modal.vue';

    const FormGenerator = defineAsyncComponent(() =>
        import(
            /* webpackChunkName: "lx-form-generator" */
            '../../../../hosted-form/form-generator.vue'
        )
    );

    export default {
        components: {
            FormGenerator,
            modal,
        },
        props: {
            currentSurveyJSON: {
                type: String,
                required: true,
            },
            modalId: {
                type: String,
                required: true,
            },
        },
        methods: {
            onUpdateData(survey) {
                this.$emit('onUpdateData', survey);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../../hosted-form/styles.scss';

    .modal-form-generator {
        :deep(.sv-components-row) {
            background-color: #f3f3f3;
        }
    }
</style>
